module.exports = __webpack_public_path__ + "static/jfall-222061235af97f15e93fe2aea63711f0.png";